import * as actionTypes from "../actions/actionTypes";

const initialState = {
  report: [],
  isReportSearched: false,
  error: null,
  showSpinner: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_REPORTS:
      return {
        ...state,
        report: action.response,
        showSpinner: false,
        hideResult: false,
      };
    case actionTypes.RESET_SEARCH_REPORTS:
      return {
        ...state,
        report: [],
        showSpinner: false,
        hideResult: false,
      };
    case actionTypes.IS_REPORT_SEARCHED:
      return {
        ...state,
        isReportSearched: action.response,
      };
    case actionTypes.SET_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actionTypes.SEARCH_REPORT_NOT_FOUND:
      return {
        ...state,
        error: { message: "No Reports found for the search." },
        hideResult: true,
      };
    case actionTypes.SEARCH_REPORT_FAILURE:
      return {
        ...state,
        error: { message: "Oops!! Something didn't work. Pls try again." },
      };
    case actionTypes.REPORT_LOAD_SPINNER:
      return {
        ...state,
        showSpinner: action.response,
      };
    default:
      return state;
  }
};

export default reducer;
